import {
  Button,
  DisclosureGroup,
  DisclosurePanel,
} from 'react-aria-components';
import styled from 'styled-components';

export const Disclosures = styled(DisclosureGroup)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
`;

export const Trigger = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: var(--spacing-base);
  background: var(--white);
  border: 1px solid var(--grey-200);
  border-radius: var(--radius-base);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  color: var(--black);

  &[data-focus-visible-within] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);

    & :focus-visible {
      outline: 0;
    }
  }
    
  & svg {
    width: 16px;
    transform: rotate(-180deg);

    & path {
      stroke: var(--grey-500);
    }
  }

  &[aria-expanded="true"] {
    border-color: var(--grey-400);
    font-weight: var(--font-weight-semibold);

    & svg {
      transform: rotate(0);
    }
  }
`;

export const Panel = styled(DisclosurePanel)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  padding-block: var(--spacing-base);

  &[hidden="until-found"] {
    padding: 0;
  }
`;

export const Highlight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-base);
  padding: 12px;
  background: var(--brand-50);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);

  & dl {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-base);
    color: var(--grey-700);

    & > div {
      display: flex;
      flex-direction: row;
      gap: var(--spacing-small);

      & dd {
        font-weight: var(--font-weight-xbold);
      }
    }
  }
`;

export const Text = styled.p`
  font-size: var(--font-size-text-sm);
  color: var(--grey-700);

  & > span {
    font-weight: var(--font-weight-semibold);
  }
`;
